import { useAccountRepository } from '@frontend/repository';
import { useNavigate } from 'react-router-dom';

export const useCreateContentModal = () => {
    const { currentAccount } = useAccountRepository();
    const navigate = useNavigate();
    const contentModalId = 'create-notification-content-modal';

    return {
        currentAccount,
        contentModalId,
        navigate
    };
};
